import { useState, VFC, useCallback } from 'react';
import { Button, Col, Row } from 'antd';
import { CloseOutlined, DownloadOutlined, FilterOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useAuth } from '@isocel/front-common';

import PackageCount from './packageCount/PackageCount';
import DashboardFilter from './filter/DashboardFilter';
import PackagingFlowTable from './table/PackagingFlowTable';
import './Dashboard.less';
import { useDashboardContext, DashboardProvider } from '../../context/DashboardContext';
import { downloadCsvFile } from './downloadCsv/downloadCsv';

const Dashboard: VFC = () => {
    const [showFilters, setShowFilters] = useState(false);
    const {
        selectedStoreIds,
        selectedPackageIds,
        selectedStatus,
        selectedVoucherStatus,
        differenceReported,
        selectedSupplierIds,
        selectedParcPalettIds,
        selectedStartDate,
        selectedEndDate,
        hasTableData,
    } = useDashboardContext();

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };
    const { user } = useAuth();

    const handleDownloadClick = useCallback(async () => {
        const params = {
            page: 0,
            pageSize: 100,
            differenceReported,
            packageIds: selectedPackageIds,
            status: selectedStatus,
            voucherStatus: selectedVoucherStatus,
            storeIds: selectedStoreIds,
            supplierIds: selectedSupplierIds,
            parcPalettIds: selectedParcPalettIds,
            startDate: selectedStartDate ? moment(selectedStartDate) : undefined,
            endDate: selectedEndDate ? moment(selectedEndDate) : undefined,
            organization: user?.organization?.id ?? '',
        };

        await downloadCsvFile(params);
    }, [
        differenceReported,
        selectedPackageIds,
        selectedStatus,
        selectedVoucherStatus,
        selectedStoreIds,
        selectedSupplierIds,
        selectedParcPalettIds,
        selectedStartDate,
        selectedEndDate,
        user?.organization?.id,
    ]);

    return (
        <div>
            <Row justify="space-between" align="middle">
                <Col>
                    <div className="filter-button">
                        <h1>Tableau de bord</h1>
                        <Button
                            type="primary"
                            onClick={toggleFilters}
                            icon={showFilters ? <CloseOutlined /> : <FilterOutlined />}
                        >
                            {showFilters ? 'Fermer les filtres' : 'Filtrer les informations'}
                        </Button>
                    </div>
                </Col>
            </Row>
            {showFilters && (
                <div className="table-container">
                    <DashboardFilter />
                </div>
            )}
            <PackageCount />
            <Row justify="end">
                <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownloadClick}
                    disabled={!hasTableData} // Disable button if no table data
                ></Button>
            </Row>
            <PackagingFlowTable />
        </div>
    );
};

const DashboardWrapper: VFC = () => (
    <DashboardProvider>
        <Dashboard />
    </DashboardProvider>
);

export default DashboardWrapper;
